import { Component } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { AlertController, LoadingController } from "ionic-angular";
import { NavController, NavParams } from "ionic-angular";
import { ViewController } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { Member } from "../../models/interfaces/member.model";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "searchcomponent",
  templateUrl: "searchcomponent.html"
})
export class SearchComponent {
  private ref: string = "member";  // Observable collection
  private member$: Observable<Member[]>;
  private member: Member;
  private tmpSearchObject;
  private pi_rate: number;
  private objectKeys = Object.keys;
  private observable$: any;
  private sel = [];
  private type;
  private selectedArray: {
    [index: string]: boolean;
  } = {};
  private checkedMember: boolean;
  private pi;
  private searchForm: FormGroup;
  private styleName: string ="";

  constructor(private configService: ConfigService,public navCtrl: NavController, public navParams: NavParams,
              private formBuilder: FormBuilder, public alertCtrl: AlertController,
              public loadingCtrl: LoadingController, private db: DbserviceProvider,
              public viewCtrl: ViewController) {
    console.log("SearchComponent constructor");
    this.styleName=this.configService.getConfig("STYLENAME");

    this.sel = this.navParams.get("sel");
    this.type = this.navParams.get("type");
    this.sel.forEach((ind) => this.selectedArray[ind] = true);

    this.searchForm = this.formBuilder.group({
      "mb_hashname": [""]});
    this.tmpSearchObject = this.observable$;
  }

  private search(searchbar) {
    console.log("SearchComponent search");
    let q = searchbar.target.value;

    if (q.trim() === "") {
      this.observable$ = this.tmpSearchObject;
      return;
    }
    this.observable$ = this.observable$
      .map((arrays) => arrays.filter((arrayEl) => arrayEl.mb_hashname.toLowerCase().indexOf(searchbar.target.value.toLowerCase()) > -1));
  }

  private setSelection(event, mbr) {
    console.log("SearchComponent setSelection");

    if (event.value === true) {
      this.selectedArray[mbr.mb_hashname] = event.value;
    }
    else {
      delete this.selectedArray[mbr.mb_hashname];
    }
  }

  private addHareline() {
    console.log("SearchComponent addHareline");
    this.viewCtrl.dismiss(this.selectedArray);
  }

  private goback() {
    console.log("SearchComponent goback");
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/components/searchcomponent/searchcomponent.ts